import { useCallback } from "react";
import { NL_fieldPatterns } from "../util/NL_fieldPatterns";
import { useValidation as useValidationCommon } from '../../hooks/useValidation'
import { validateInvoices } from "../util/itemsTabValidation";
import { INIT_VALIDATION_ERRORS } from '../../commonActionTypes'

export const useValidation = (tabName) => {

    const { validateError, updateError } = useValidationCommon(tabName)

    const initItemsTabValidation = useCallback(() => {
        return (dispatch, getState) => {
            const { InvoicesReducer } = getState();
            const newInvoices = InvoicesReducer?.invoices?.map((itm) => {
                return { ...itm, lineItems: InvoicesReducer?.lineItems[itm?.invoiceId] }
            })
            const itemErrors = validateInvoices(newInvoices, NL_fieldPatterns(false)()?.items)
            dispatch({
                type: INIT_VALIDATION_ERRORS,
                payload: { items: itemErrors }
            })
        };
    }, [])

    return { validateError, initItemsTabValidation, updateError }
}